export function useTranslationPath(path, key) {
  let normalizedPath = path.replace(/\\/g, '/')

  const srcIndex = normalizedPath.indexOf('src/')

  if (srcIndex !== -1) {
    normalizedPath = normalizedPath.slice(srcIndex + 4)
  }

  let pathParts = normalizedPath.split('/')
  let fileName = pathParts.pop()
  if (fileName) {
    // Only strip extension if it matches ?(c|m)[jt]s?(x) or vue, ignoring query strings
    const match = fileName.match(/^(.*)\.(?:(?:c|m)?[jt]s(?:x)?|vue)(?:\?.*)?$/)
    if (match) {
      fileName = match[1]
    }
    pathParts.push(fileName)
  }

  pathParts = pathParts.filter(Boolean)

  pathParts = pathParts.map((str) => {
    let s = str.replace(/-([a-z])/g, (_, char) => char.toUpperCase())

    return s.charAt(0).toLowerCase() + s.slice(1)
  })

  if (key) {
    pathParts.push(key)
  }

  return pathParts.join('.')
}
